<div class="container">
    <h2 class="my-5">Transportation</h2>

    <section class="row" id="bus">
      <div class="col-md-3">
        <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
      </div>
      <div class="col-md-9">
        <h3>Buses</h3>
        <p>
          Taniti offers a reliable and affordable public bus system that serves Taniti City from 5 a.m. to 11 p.m. daily. These
          buses are a convenient way for residents and tourists alike to travel throughout the city, with frequent stops near
          major attractions, hotels, and shopping areas. For those looking to explore beyond the city limits, a network of
          privately operated buses connects Taniti City to other parts of the island. These intercity routes vary in schedule
          and cost, but they provide access to more remote villages, beaches, and natural attractions.
        </p>
      </div>
    </section>

    <hr class="my-5">

    <section class="row" id="taxi">
        <div class="col-md-9">
            <h3>Taxi</h3>
            <p>
              Taxis are readily available throughout Taniti City and are a convenient option for travelers who prefer direct,
              door-to-door transportation. They can be hailed on the street, requested by phone, or arranged through hotel services.
              Fares are typically metered, and drivers are familiar with the island’s main tourist destinations. While taxis are
              less common outside the city, they can often be pre-arranged for longer trips or airport transfers.
            </p>
        </div>
        <div class="col-md-3">
            <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
        </div>
    </section>

    <hr class="my-5">

    <section class="row" id="rental">
        <div class="col-md-3">
            <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
        </div>
        <div class="col-md-9">
            <h3>Rental Car</h3>
            <p>
              For visitors wanting the flexibility to explore the island at their own pace, rental cars are available from a
              locally operated agency located just outside the airport. A valid driver's license and a minimum age requirement
              are typically needed to rent a vehicle. Driving in Taniti is straightforward, with well-maintained roads and clear
              signage, especially around Taniti City and other popular tourist areas. Renting a car is a great option for travelers
              interested in visiting outlying beaches, hiking trails, or remote cultural sites.
            </p>
        </div>
    </section>

    <hr class="my-5">

    <section class="row" id="bike">
        <div class="col-md-9">
            <h3>Bike</h3>
            <p>
              Bicycles are a popular and eco-friendly way to get around Taniti, especially within the relatively flat and bike-friendly
              Taniti City. Several vendors throughout the city offer bike rentals, often including helmets, which are required by law
              for all riders. Whether you're cycling along the coast or through local neighborhoods, biking provides a scenic and
              enjoyable way to experience the island. Many tourists choose to stay in the area surrounding Merriton Landing, which is
              not only bike-friendly but also very walkable, making it easy to explore cafes, shops, and attractions on foot or two
              wheels.
            </p>
        </div>
        <div class="col-md-3">
            <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
        </div>
    </section>
</div>
